import React, { useEffect } from "react";
import ImportDetailsProps from "../importDetailsProps";

export const SpecificRecordsCustomImportDetails: React.FC<ImportDetailsProps> = props => {

    useEffect(() => {
        props.onIsValidChanged(isValid());
    }, [props.request]);

    function isValid(): boolean {
        if (props.request.recordIds.length === 0) return false;
        return true;
    }

    return <>
        <p>System will retrieve the specified contracts from ERP.</p>
    
        <div>
            <strong>Record IDs (one per line):</strong>
        </div>
        <div>
            <textarea className="form-control" rows={5}
                value={props.request.recordIds.join('\n')}
                onChange={ev => props.onChange({ 
                    ...props.request, 
                    recordIds: ev.target.value
                                .split('\n')
                                .map(line => line.trim())
                    })}>
            </textarea>
        </div>
    </>;
}